import Web3 from "web3";
import React, { useEffect, useState } from "react";
import { Offcanvas } from 'react-bootstrap';
import './EarniMobileNav.css';
import { BreakpointProvider, setDefaultBreakpoints } from "react-socks";
//import { header } from 'react-bootstrap';
import { Link } from '@reach/router';
import { useTranslation } from "react-i18next";
import useOnclickOutside from "react-cool-onclickoutside";
import LOGO from "../../../assets/images/Logo_EIV_Full_Gradient-Horizon.png"
import LOGO_WHITE from "../../../assets/images/Logo_EIV_Full_White-Horizon1.png"
import LOGO_ICON from "../../../assets/images/Logo_EIV_Gradient-Icone.png"
import { useHistory, useLocation } from 'react-router-dom';
import { EPATHS } from "../../../routes/paths.enum";
import { EROLES } from "../../../utils/constants/roles.enum";
import { categoryOf, categoryVisual, relativeTime } from "../../../utils/functions/notificationMeta";
import * as NotificationService from "../../../services/NotificationService";
import * as selectors from '../../../store/selectors';
import * as actions from '../../../store/actions';
import * as thunkActions from '../../../store/actions/thunks';
import { readStoredUser, patchStoredUser, removeStoredUser } from '../../../utils/auth/userStorage';
import { useSelector, useDispatch } from 'react-redux';
import api from "../../../core/api";
import { logout } from "../../../utils/functions/authenticate";
import SmartImage from '../../../components/ui/SmartImage';
import EarnicoinsBalance from '../../../components/ui/EarnicoinsBalance';
import { getAvatarUrl, getAvatarSrcSet, DEFAULT_AVATAR } from '../../../utils/functions/imageUrl';
import { HeaderDAV2 } from './HeaderDAV2.styles';
import ModalNoMetamask from "../../../components/Servererror/modalNoMetamask";
import EarniWalletModal from "../../../components/EarniWalletModal";
import ModalUELogin from "../../../components/Servererror/modalUELogin";
import erc20Abi from "../../../artifacts/contracts/IERC20.sol/IERC20.json";
import * as AuthService from "../../../services/AuthService";
import * as SupportService from "../../../services/SupportService";
import SessionTimeoutModal from "../../Modals/SessionTimeoutModal";
import AuthGateModal from "../../Modals/AuthGateModal";
import EpicRegisterModal from "../../Modals/EpicRegisterModal";
import CartIcon from "../../../components/ui/cart/CartIcon";
import LanguageSelect from "../../../components/ui/LanguageSelect";
import CartCheckoutModal from "../../../components/cart/CartCheckoutModal";
import { selectCartItems, selectCartTotal } from '../../../store/slices/cartSlice';
import ReferralQuickShareModal from '../../../components/ui/ReferralQuickShareModal';
import ReferralAlreadyMemberModal from '../../../components/ui/ReferralAlreadyMemberModal';
import { getMyReferral } from '../../../services/ReferralService';
import { shortAddress } from '../../../utils/format';
import { SERVER_URL } from '../../../core/config';
import { COLORS } from '../../../components/ui/theme';
import { resolvedChainId, EXPECTED_CHAIN_ID_HEX, NETWORK_LABEL, ADD_CHAIN_PARAMS } from '../../../components/EarniWalletModal/config/wagmiConfig';

setDefaultBreakpoints([
  { xs: 0 },
  { l: 1199 },
  { xl: 1200 }
]);

const NavLink = props => {
  const navHistory = useHistory();
  return (
    <Link
      {...props}
      onClick={(e) => {
        if (props.onClick) props.onClick(e);
        // Le Link @reach/router ne pilote PAS le rendu react-router-dom (history séparé) →
        // l'URL changeait mais la page ne se re-rendait pas (bug liens drawer mobile :
        // l'URL passait à /map etc. sans changer de page). On pousse react-router-dom — même
        // mécanisme que les items desktop via handleRedirectToPath. Garde anti-double-push :
        // si l'onClick passé a déjà navigué (cas desktop), window.location.pathname == to → skip.
        const to = typeof props.to === 'string' ? props.to : '';
        if (to && to !== '#' && navHistory && window.location.pathname !== to) {
          try { navHistory.push(to); } catch (err) { /* noop */ }
        }
      }}
      getProps={({ isCurrent }) => {
        // getProps RETURN écrase les props du Link → on FUSIONNE le className passé (ex:
        // "emn-link") avec active/non-active, sinon la classe de style est perdue.
        return {
          className: [props.className, isCurrent ? 'active' : 'non-active'].filter(Boolean).join(' '),
        };
      }}
    />
  );
};

const Header = function({ className }) {
    const { t } = useTranslation();
    // eslint-disable-next-line
    const [openMenu, setOpenMenu] = React.useState(false);
    // eslint-disable-next-line
    const [openMenu1, setOpenMenu1] = React.useState(false);
    // const [isTimeout, setTimeout] = React.useState(false);
    const [isShowUELogin, setShowUELogin] = React.useState(false);
    const [isSticky,setIsSticky] = React.useState(false);
    const [openNoWalletModal, setOpenNoWalletModal] = React.useState(false);
    const [walletModalOpen, setWalletModalOpen] = React.useState(false);
    /* Raison d'ouverture de la modal login : '' = générique ; 'darkmode' = ouverte via le toggle
     * dark mode → affiche la bannière contextuelle (cf. handleThemeToggle + EarniWalletModal). */
    const [walletModalReason, setWalletModalReason] = React.useState('');
    const dispatch = useDispatch();
    const [isWrongNetwork, setWrongNetwork] = React.useState(false);
    /* Wallet réellement connecté au site (comptes autorisés). Le badge "mauvais réseau"
     * n'a de sens que dans ce cas — sinon il s'affichait pour tout visiteur MetaMask. */
    const [walletConnected, setWalletConnected] = React.useState(false);
    const [isEpicRegister, setEpicRegister] = React.useState(false);
    const [copiedAddr, setCopiedAddr] = React.useState(false);
    const [isCheckoutOpen, setIsCheckoutOpen] = React.useState(false);
    const pendingCheckoutRef = React.useRef(false);
    /* Intention dark mode mémorisée : clic toggle en déconnecté → modal login ; à la connexion
     * réussie, le toggle bascule en dark (gesture complétée). Reset si la modal est fermée sans login. */
    const pendingDarkRef = React.useRef(false);
    const [referralModalOpen, setReferralModalOpen] = React.useState(false);
    const [alreadyMemberOpen, setAlreadyMemberOpen] = React.useState(false);
    const [referralLink, setReferralLink] = React.useState('');
    /* Dark mode toggle (PARTIE MENU uniquement — cf. tasks/active/TRACK-2026-06-19-darkmode-menu.md).
     * Toggle PUREMENT VISUEL (comme la preview validée) : aucune persistance ni application de thème ici.
     * La persistance compte (preferredTheme) + le rendu sombre réel sont à la charge de la SESSION DARK
     * MODE dédiée. Démarre toujours sur 'light' ; déconnecté → reste OFF (dark = préférence compte). */
    const [themeMode, setThemeMode] = React.useState('light');

    const cartItems = useSelector(selectCartItems);
    const cartTotal = useSelector(selectCartTotal);

    const notificationsState = useSelector(selectors.notificationsState);
    const balanceState = useSelector(selectors.balance);
    const signedUser = useSelector(selectors.user);

    /* Dark mode = préférence de compte. Applicateur UNIQUE du thème réel (html[data-theme]) :
     * - déconnecté → light + retrait de data-theme (le rendu sombre exige d'être connecté) ;
     * - connecté → lit user.preferredTheme et pose/retire data-theme + synchronise le visuel du toggle.
     * Tourne au mount (chaque page re-monte le Header), au login et au sign-out. */
    useEffect(() => {
      const root = document.documentElement;
      if (!signedUser?.accessToken) {
        setThemeMode('light');
        root.removeAttribute('data-theme');
        return;
      }
      const pref = signedUser.preferredTheme === 'dark' ? 'dark' : 'light';
      setThemeMode(pref);
      if (pref === 'dark') root.setAttribute('data-theme', 'dark');
      else root.removeAttribute('data-theme');
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signedUser?.accessToken, signedUser?.preferredTheme]);

    // Charger le lien referral quand l'user est connecté (fire-and-forget)
    useEffect(() => {
      if (signedUser && signedUser.id) {
        getMyReferral()
          .then(data => { if (data?.link) setReferralLink(data.link); })
          .catch(() => {});
      }
    }, [signedUser?.id]); // eslint-disable-line react-hooks/exhaustive-deps

    // Copie l'adresse wallet COMPLÈTE dans le presse-papier (l'affichage reste tronqué).
    // Pattern aligné sur PublicProfile.share() ; feedback par état local (pas de Toast DA).
    const copyWalletAddress = (e) => {
      if (e) e.stopPropagation(); // ne pas refermer le dropdown profil (btn_icon_pop)
      if (!signedUser.metamask || !navigator.clipboard) return;
      navigator.clipboard.writeText(signedUser.metamask)
        .then(() => { setCopiedAddr(true); setTimeout(() => setCopiedAddr(false), 1500); })
        .catch(() => {});
    };
    const isTimeout = useSelector(selectors.isTimeout);
    const notifications = notificationsState.data ? notificationsState.data : [];
    const history=useHistory();
    const web3 = window.ethereum ? new Web3(Web3.givenProvider) : null;
    const location = useLocation();
    const walletRegisterRequest = useSelector(selectors.walletRegisterRequest);

    // Lien de parrainage : arriver avec ?ref=.
    //  - délogué → ouvre la modal de connexion (bannière + tracking parrainage, remplace /register).
    //  - déjà connecté → ne peut pas être parrainé → modal "déjà membre" (évite le loop de la modal
    //    de connexion en mode manage).
    // Le token localStorage ne suffit PAS (il peut être périmé/invalide) : on valide la session
    // contre le backend (AuthService.sessionCheck, même appel que le sessionCheck périodique) avant
    // d'afficher "déjà membre". Token absent → délogué direct. Token présent mais invalide/expiré
    // (401) → traiter comme délogué : nettoyer la session périmée (logout, skipRedirect pour rester
    // sur la page) puis ouvrir la modal de connexion.
    useEffect(() => {
      const refCode = new URLSearchParams(window.location.search).get('ref');
      if (!refCode) return;
      let token = '';
      token = readStoredUser()?.accessToken || '';
      if (!token) { setWalletModalOpen(true); return; }
      AuthService.sessionCheck()
        .then(() => { setAlreadyMemberOpen(true); })
        .catch((err) => {
          if (err.response?.status == '401') {
            // Session périmée : nettoyer (sans rediriger) puis ouvrir la modal de connexion.
            logout(dispatch, thunkActions.setUser, history, true);
          }
          setWalletModalOpen(true);
        });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Flux legacy login() (wallet inconnu hors modal) : demande l'ouverture de la modal en
    // inscription au lieu de l'ancienne redirection /register. Flag consommé une fois.
    useEffect(() => {
      if (walletRegisterRequest) {
        setWalletModalOpen(true);
        dispatch(actions.setWalletRegisterRequest(false));
      }
    }, [walletRegisterRequest, dispatch]);

    // Fix 2026-06-15 — getChainId() retiré du render body (appelé à chaque re-render = RPC spam).
    // Remplacé par une lecture synchrone de networkVersion dans useEffect ci-dessous.

    const closeMenu = () => {
      setOpenMenu(false);
    };
    const closeMenu1 = () => {
      setOpenMenu1(false);
    };

    const ref1 = useOnclickOutside(() => {
      closeMenu1();
    });

    const [showmenu, btn_icon] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [showpop, btn_icon_pop] = useState(false);
    const [shownot, btn_icon_not] = useState(false);
    const closePop = () => {
      btn_icon_pop(false);
    };
    const closeNot = () => {
      btn_icon_not(false);
    };
    const refpop = useOnclickOutside(() => {
      closePop();
    });
    const refpopnot = useOnclickOutside(() => {
      closeNot();
    });

    // Fix 2026-06-15 — chainChanged listener : enregistrement UNIQUE avec cleanup.
    // Avant : [web3] comme dépendance → web3 = new Web3() recréé à chaque render → useEffect
    // re-exécuté à chaque render → chainChanged handlers s'accumulent sans jamais être retirés.
    // Fix : deps=[] (1 seul enregistrement) + removeListener dans le cleanup.
    useEffect(() => {
      if (!window?.ethereum) return;
      // Détection réseau ROBUSTE : on lit le chainId via `eth_chainId` (hex) plutôt que
      // `window.ethereum.networkVersion` (déprécié par MetaMask → renvoie parfois null,
      // ce qui faisait un faux "mauvais réseau"). La chaîne attendue = `resolvedChainId`
      // (= chaîne wagmi active : Avalanche Fuji sur staging, mainnet en prod) → source
      // unique, plus de divergence avec REACT_APP_AVAX_CHAIN_ID.
      const evalChain = (raw) => {
        if (raw == null) return; // chaîne inconnue → ne pas basculer (évite le faux positif)
        const s = String(raw).trim().toLowerCase();
        const cur = s.startsWith('0x') ? parseInt(s, 16) : parseInt(s, 10);
        if (Number.isFinite(cur)) setWrongNetwork(cur !== resolvedChainId);
      };
      const handleChainChanged = (chainId) => evalChain(chainId);
      // Le badge "mauvais réseau" ne doit s'afficher QUE si un wallet est réellement
      // connecté au site (sinon un simple utilisateur MetaMask sur une autre chaîne,
      // même déconnecté du site, le voyait clignoter en permanence — bug rapporté).
      // eth_accounts NE déclenche PAS de prompt : lecture passive des comptes autorisés.
      const handleAccountsChanged = (accounts) => {
        setWalletConnected(Array.isArray(accounts) && accounts.length > 0);
      };
      // Vérifications initiales (réseau + comptes) sans prompt.
      try {
        window.ethereum.request({ method: 'eth_chainId' }).then(evalChain).catch(() => {});
        window.ethereum.request({ method: 'eth_accounts' })
          .then((accs) => setWalletConnected(Array.isArray(accs) && accs.length > 0))
          .catch(() => {});
      } catch (_) { /* provider sans request → ignore */ }
      window.ethereum.on('chainChanged', handleChainChanged);
      window.ethereum.on('accountsChanged', handleAccountsChanged);
      return () => {
        window.ethereum.removeListener('chainChanged', handleChainChanged);
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      const header = document.getElementById("myHeader");
      const totop = document.getElementById("scroll-to-top");
      const sticky = header.offsetTop;
      const scrollCallBack = window.addEventListener("scroll", () => {
        const offset=window.scrollY;
        if(offset > 20 ) {
          setIsSticky(true);
        }
        else{
          setIsSticky(false);
        }
      
        btn_icon(false);
        if (window.pageYOffset > sticky) {
          header?.classList.add("sticky");
          totop?.classList.add("show");
          // 
          
          
        } else {
          header?.classList.remove("sticky");
          totop?.classList.remove("show");
          // 
        } if (window.pageYOffset > sticky) {
          closeMenu();
        }
      });
      // Hydratation de session au boot RETIRÉE (vague 4 lot 3) : elle est désormais faite
      // une seule fois dans store/index.js (readStoredUser → dispatch setUser). La refaire ici
      // dupliquait le dispatch au mount du Header.
      return () => {
        window.removeEventListener("scroll", scrollCallBack);  
      };
      // eslint-disable-next-line
    }, []);

    const fetchData = async () => {
      if (!web3) return; // no MetaMask / headless env — skip on-chain balance fetch
      const account = signedUser.metamask;
      const tokenAddress = process.env.REACT_APP_EIV_ADDRESS;
      const contract = new web3.eth.Contract(erc20Abi.abi, tokenAddress);
      const response = await contract.methods.balanceOf(account).call();
      dispatch(actions.setBalance(Web3.utils.fromWei(response)));
      dispatch(thunkActions.fetchNotifications());
    }

    // BUG AUTO-LOGOUT — Désactivé 2026-06-06.
    // Cet effet déloguait l'utilisateur dès que MetaMask publiait `accounts:[]` au mount
    // du Header (ex. après hard navigation vers `/profile/:id` depuis un lien externe,
    // ou après clic sur "View Notifications" via NavLink). Le déloggage marketplace ne
    // doit PAS dépendre de l'état MetaMask — il est géré par le JWT (`sessionCheck` toutes
    // les 15 min) et par un logout explicite via le menu profil.
    // Cf. tasks/auto-logout-tracking.md (si on veut le ré-implémenter proprement plus tard,
    // avec détection "wasConnected -> becameDisconnected" et UNIQUEMENT sur la page wallet).
    /*
    useEffect(() => {
      if(window?.ethereum?._state?.accounts !== null && window?.ethereum?._state?.accounts?.length === 0 && signedUser.accessToken && localStorage.getItem('_isEpic') !== 'true') {
        logout(dispatch, thunkActions.setUser, history);
      }
      // eslint-disable-next-line
    } ,[window?.ethereum?._state?.accounts])
    */

    useEffect(() => {
      if(signedUser?.accessToken && !isTimeout) {
        fetchData();
        const interval = setInterval(() => {
          AuthService.sessionCheck()
            .then(res => {})
            .catch(err => {
              if(err.response?.status == '401') {
                // Session expirée : mémoriser la page courante, vider l'état user (page passe
                // en mode visiteur) ET ouvrir le modal de reconnexion.
                // L'ordre est important : _redirectAfterLogin sauvegardé AVANT setUser({}) pour
                // éviter que la re-render d'une ProtectedRoute change la pathname à '/'.
                const _curPath = window.location.pathname + window.location.search;
                if (_curPath && _curPath !== '/') {
                  try { localStorage.setItem('_redirectAfterLogin', _curPath); } catch(e) {}
                }
                removeStoredUser();
                dispatch(actions.setUser({}));        // page re-render en mode visiteur
                dispatch(actions.setIsTimeout(true)); // modal de reconnexion par-dessus
                clearInterval(interval);
              }
            });
        }, 900000);

        return () => clearInterval(interval);
      }
      // eslint-disable-next-line
    }, [signedUser]);

    useEffect(() => {
      if(signedUser?.accessToken) {
        if(!signedUser?.epicUserId && localStorage.getItem('_first')) {
          setEpicRegister(true);
        }
        if(signedUser?.epicUserId) {
          setEpicRegister(false);
        }
      }
    }, [signedUser?.epicUserId, localStorage.getItem('_first')]);

    const handleRedirectToPath=(path)=>{
        history.push({pathname:path});
    }

    /* Toggle dark/light depuis le header (PARTIE MENU, purement visuel). Garde connexion : le dark mode
     * est une préférence de compte → délogué = ouvre EarniWalletModal (login/create), aucun changement
     * du toggle. Connecté = bascule visuelle uniquement. Persistance + thème réel = session dark mode. */
    const handleThemeToggle = () => {
      if (!signedUser?.accessToken) { pendingDarkRef.current = true; setWalletModalReason('darkmode'); setWalletModalOpen(true); return; }
      const next = themeMode === 'dark' ? 'light' : 'dark';
      /* Persistance compte (miroir preferredLanguage) : store + localStorage._user + backend (fire-and-forget).
       * L'effet [accessToken, preferredTheme] applique html[data-theme] + le visuel du toggle. */
      dispatch(actions.setUser({ ...signedUser, preferredTheme: next }));
      patchStoredUser({ preferredTheme: next }); // persiste _user (gardé par accessToken)
      AuthService.updateUser(signedUser.id, { preferredTheme: next })
        .catch(e => console.error('[theme] preferredTheme sync:', e && e.message));
    };

    /* Connexion wallet directe depuis le header (remplace l'ancienne page /wallet).
     * Ouvre EarniWalletModal ; onSuccess identique au composant <Wallet/> historique. */
    const handleWalletSuccess = (user) => {
      dispatch(actions.setUser(user));
      /* Si la connexion vient d'un clic toggle dark mode (déconnecté), compléter la gesture : basculer
       * le toggle en dark. Indépendant du flux checkout. */
      if (pendingDarkRef.current) {
        pendingDarkRef.current = false;
        /* Login déclenché par le toggle dark : persiste dark (le reste applique via l'effet). */
        dispatch(actions.setUser({ ...user, preferredTheme: 'dark' }));
        patchStoredUser({ preferredTheme: 'dark' });
        if (user?.id) AuthService.updateUser(user.id, { preferredTheme: 'dark' })
          .catch(e => console.error('[theme] preferredTheme sync (login):', e && e.message));
      }
      if (pendingCheckoutRef.current) {
        pendingCheckoutRef.current = false;
        setIsCheckoutOpen(true);
      } else {
        try {
          const returnTo = localStorage.getItem('_redirectAfterLogin');
          if (returnTo) { localStorage.removeItem('_redirectAfterLogin'); history.push(returnTo); }
        } catch (e) { /* silencieux */ }
      }
    };

    const handleLogout = () => {
      logout(dispatch, thunkActions.setUser, history);
    }

    const switchNetwork = async () => {
      if (!window?.ethereum) return;
      dispatch(actions.setLoading(true));
      try {
        // chainId TOUJOURS en hexadécimal (EIP-3085/3326). EXPECTED_CHAIN_ID_HEX dérive
        // de la chaîne wagmi active (ex : '0xa869' pour Fuji).
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: EXPECTED_CHAIN_ID_HEX }],
        });
      } catch (err) {
        // 4902 = chaîne absente du wallet → on propose de l'ajouter (Fuji n'est pas
        // pré-installé dans MetaMask), puis le wallet bascule dessus.
        if (err && (err.code === 4902 || err.code === -32603)) {
          try {
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [ADD_CHAIN_PARAMS],
            });
          } catch (addErr) { /* refus/échec ajout → no-op, l'utilisateur reste sur sa chaîne */ }
        }
        // autres erreurs (refus utilisateur…) → no-op silencieux
      }
      dispatch(actions.setLoading(false));
    }
  

    // Pages modernes (DA V2) : navbar blanc solide + logo/texte sombres dès le haut
    // de page (pas de hero sombre — §40). Voir .navbar.solidnav dans Styles.js.
    // Exclus (heros sombres conservés) : Home, Get Started, Map/Land details, nft detail.
    const solidNav = [
      '/notifications', '/profile', '/author', '/transactions', '/collection',
      '/my-collectibles', '/mycollectibles', '/mynfts', '/gain', '/coupon', '/bids', '/authors',
      '/explore', '/setting', '/createoptions', '/createmultiple', '/admin-action',
      '/myprofile', '/editprofile',
      '/profilesmanagement', '/usdc-avax',
      // Pages DA V2 à fond clair (§40) — menu invisible si absent car logo/nav blancs sur fond blanc.
      '/land', '/land-group', '/3d_asset',
      // Storefront earnicoins + gestion abonnement (DA V2 fond clair) — logo blanc invisible sinon.
      '/earnicoins', '/account',
      // Support (fond clair DA V2)
      '/support',
      // Dropdown profil DA V2 sur PageShell GREY (fond clair) — logo blanc invisible sinon.
      '/portfolio', '/watchlist',
      // Globe /activity (fond clair en light) — logo blanc invisible sinon.
      '/activity',
    ].some((p) => window.location.pathname.toLowerCase().includes(p))
      // /map refondu DA V2 (fond clair) — match EXACT pour ne pas capter /tile-map-v2 (canvas sombre).
      || window.location.pathname.toLowerCase() === '/map';

    return (
      <header className={`navbar ${solidNav ? 'solidnav' : ''} ${window.location.pathname.toLowerCase() === '/explore'
      || window.location.pathname.toLowerCase() === '/authors' 
      || window.location.pathname.toLowerCase() === '/land' 
      || window.location.pathname.toLowerCase() === '/collection'
      || window.location.pathname.toLowerCase() === '/my-collectibles'
      || window.location.pathname.toLowerCase() === '/gain'
      || window.location.pathname.toLowerCase() === '/editprofile'
      || window.location.pathname.toLowerCase() === '/wallet'
      || window.location.pathname.toLowerCase() === '/myprofile'
      || window.location.pathname.toLowerCase() === '/notifications'
      || window.location.pathname.toLowerCase() === '/transactions'
      || window.location.pathname.toLowerCase() === '/createoptions'
      || window.location.pathname.toLowerCase() === '/createmultiple'
      || window.location.pathname.toLowerCase() === '/setting'
      || window.location.pathname.toLowerCase() === '/profilesmanagement'
      || window.location.pathname.toLowerCase() === '/reset-password'
      || window.location.pathname.toLowerCase() === '/confirm-password'
      || window.location.pathname.toLowerCase() === '/change-verification'
      || window.location.pathname.toLowerCase() === '/admin-action'
      || window.location.pathname.toLowerCase().includes('/author/')
      || window.location.pathname.toLowerCase().includes('/coupon')
      || window.location.pathname.toLowerCase().includes('/collection/')
      || window.location.pathname.toLowerCase() === '/map'
      ? '' : 'white'} ${className}`} id="myHeader">
     <div className='container'>
       <div className='row w-100-nav'>
          <div className='logo px-0'>
              <div className='navbar-title navbar-item'>
                <NavLink to={EPATHS.HOME} onClick={()=>handleRedirectToPath(EPATHS.HOME)}>
                <img
                    src={(document.documentElement.getAttribute('data-theme') !== 'dark' && (isSticky || solidNav || className === 'HOME' || window.location.pathname.includes('/nft/'))) ? LOGO : LOGO_WHITE}
                    className="img-fluid d-block"
                    alt="#"
                    style={{ width:"14vw",
                      height:"100%",
                      cursor: "pointer"}}
                  />
                  <img
                    src={(document.documentElement.getAttribute('data-theme') !== 'dark' && (isSticky || solidNav || className === 'HOME' || window.location.pathname.includes('/nft/'))) ? LOGO : LOGO_WHITE}
                    className="img-fluid d-3"
                    alt="#"
                     style={{ width:"14vw",
                      height:"100%",
                      cursor: "pointer"}}
                  />
                  <img
                    src={(document.documentElement.getAttribute('data-theme') !== 'dark' && (isSticky || solidNav || className === 'HOME' || window.location.pathname.includes('/nft/'))) ? LOGO : LOGO_WHITE}
                    className="img-fluid d-4"
                    alt="#"
                     style={{ width:"14vw",
                      height:"100%",
                      cursor: "pointer"}}
                  />
                  <img
                     src={(document.documentElement.getAttribute('data-theme') !== 'dark' && (isSticky || solidNav || className === 'HOME' || window.location.pathname.includes('/nft/'))) ? LOGO : LOGO_WHITE}
                    className="img-fluid d-none"
                    alt="#"
                     style={{ width:"14vw",
                      height:"100%",
                      cursor: "pointer"}}
                  />
                  {/* Icône mobile uniquement — masquée sur desktop via CSS */}
                  <img
                    src={LOGO_ICON}
                    className="img-fluid logo-mobile-icon"
                    alt="Earniverse"
                    style={{ cursor: "pointer" }}
                  />
                </NavLink>
              </div>
          </div>
                 
              <BreakpointProvider>

                  <div className={`menu${showmenu ? ' menu-open' : ''}`}>
                    {/* Get Started = landing fusionnée (Home + Get Started). L'ancienne entrée
                        "Home" a été retirée (fusionnée ici) — cf. preview dav2-fusion-B. */}
                    <div className='navbar-item'>
                      <NavLink to={EPATHS.HOME} onClick={()=>handleRedirectToPath(EPATHS.HOME)}>
                        <div className="dropdown-custom btn">
                          {t("Get Started")}
                          <span className='lines'></span>
                        </div>
                      </NavLink>
                    </div>

                   {/* Maps (dropdown : Map Details / Buy Land / Web Map) */}
                   <div className='navbar-item navigation'>
                      <div ref={ref1}>
                        {
                          // eslint-disable-next-line
                          <NavLink to={EPATHS.MAP} onClick={()=>handleRedirectToPath(EPATHS.MAP)}>
                            <div className="dropdown-custom btn"
                              >

                                {t("Maps")}

                              <span className='lines'></span>
                            </div>
                          </NavLink>
                        }
                      </div>
                      <div className="navigation-content">
                        {
                          // eslint-disable-next-line
                          <NavLink to={EPATHS.MAP} className="landSubmenu map-content" onClick={()=>handleRedirectToPath(EPATHS.MAP)}>
                            <div className="dropdown-custom btn">
                              {t("MapDetails")}
                              <span className='map-lines lines'></span>
                            </div>
                          </NavLink>
                        }
                        

                        {
                          // eslint-disable-next-line
                          <NavLink to={EPATHS.LAND} className="landSubmenu land-content" onClick={()=>handleRedirectToPath(EPATHS.LAND)}>
                            <div className="dropdown-custom btn">
                              {t("BuyLand")}
                              <span className='land-lines lines'></span>
                            </div>
                          </NavLink>
                        }

                        {
                          // eslint-disable-next-line
                          <NavLink to={EPATHS.TILE_MAP} className="landSubmenu land-content" onClick={()=>handleRedirectToPath(EPATHS.TILE_MAP)}>
                            <div className="dropdown-custom btn">
                              {t("WebMap")}
                              <span className='land-lines lines'></span>
                            </div>
                          </NavLink>
                        }
                      </div>
                    </div> 
                    {/* Explore (activé — preview dav2-fusion-B). Authors retiré du menu visiteur. */}
                    <div className='navbar-item'>
                      <NavLink to={EPATHS.EXPLORE}  onClick={()=>handleRedirectToPath(EPATHS.EXPLORE)}>
                        <div className="dropdown-custom btn">
                          {t("Explore")}
                          <span className='lines'></span>
                        </div>
                      </NavLink>
                    </div>
                    {/* Activity — globe 3D public d'activité mondiale (TRACK-2026-07-03-activity-globe-3d) */}
                    <div className='navbar-item'>
                      <NavLink to={EPATHS.ACTIVITY} onClick={()=>handleRedirectToPath(EPATHS.ACTIVITY)}>
                        <div className="dropdown-custom btn">
                          {t("Activity")}
                          <span className='lines'></span>
                        </div>
                      </NavLink>
                    </div>
                    {/* My Collectibles / My Collections / Settings : DÉPLACÉS dans le menu avatar
                        (dropdown profil .de-submenu-profile) — barre desktop allégée à 3 entrées
                        (Get Started · Maps · Explore). Conditions d'affichage & routes INCHANGÉES
                        (cf. profil ci-dessous + AUDIT-2026-06-11-menu-linking / PR #222). */}
                  </div>
              </BreakpointProvider>

              <div className='mainside'>
                <div style={{display:"flex", alignItems:"center", gap:"0.5rem"}}>
                  {/* Badge "mauvais réseau" — à GAUCHE du toggle. Affiché UNIQUEMENT si un wallet
                      est connecté au site ET sur la mauvaise chaîne. Clic = bascule de réseau.
                      (Plus de clignotement ni de positionnement absolu qui débordait le header.) */}
                  {walletConnected && isWrongNetwork && (
                    <span className="wrong-network-chip" onClick={() => switchNetwork()} title={`${t("WrongNetwork")} — ${NETWORK_LABEL}`}>
                      <span className="wn-dot" aria-hidden="true"></span>
                      {t("WrongNetwork")}
                    </span>
                  )}
                  {/* Dark mode toggle — 1ʳᵉ position du bloc droit (validé 2026-06-19). OFF=transparent / ON=violet DA.
                      Délogué → modal login (dark = préférence compte). Rendu sombre réel = session dark mode dédiée. */}
                  <button
                    type="button"
                    className={`theme-toggle${themeMode === 'dark' ? ' is-dark' : ''}`}
                    role="switch"
                    aria-checked={themeMode === 'dark'}
                    aria-label={t("ToggleDarkMode")}
                    title={t("ToggleDarkMode")}
                    onClick={handleThemeToggle}
                  >
                    <span className="tt-glyph tt-sun" aria-hidden="true">☀</span>
                    <span className="tt-glyph tt-moon" aria-hidden="true">☾</span>
                    <span className="tt-knob" aria-hidden="true"></span>
                  </button>
                  {/* Sélecteur de langue — connecté : en tête. Déconnecté : déplacé juste avant "Connect" (ci-dessous). */}
                  {signedUser.accessToken && <LanguageSelect />}
                  {/* Cart icon — visible pour tous les visiteurs (panier persistant) */}
                  <CartIcon onCheckout={() => {
                    if (!signedUser?.accessToken) {
                      pendingCheckoutRef.current = true;
                      setWalletModalOpen(true);
                    } else {
                      setIsCheckoutOpen(true);
                    }
                  }} />
                  {/* Support — icône cercle (délogué uniquement, route publique §357) — glyphe "?" agrandi */}
                  {!signedUser.accessToken && (
                    <div className="h-icon-btn" title={t("Support")} onClick={() => handleRedirectToPath(EPATHS.SUPPORT)} style={{cursor:'pointer'}}>
                      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                        <line x1="12" y1="17" x2="12.01" y2="17"/>
                      </svg>
                    </div>
                  )}
              {!signedUser.accessToken && <div className="h-sep" />}
              {/* Drapeau langue placé juste avant "Connect" (déconnecté) */}
              {!signedUser.accessToken && <LanguageSelect />}
              {!signedUser.accessToken &&
                  <div className='connect-wal' style={{position: 'relative'}}>
                    <a className="header-button" onClick={() => setWalletModalOpen(true)}>
                      <span className="cw-label">{t("Connect")}</span>
                    </a>
                  </div>}
                </div>
               {signedUser.accessToken &&
               <div className="" style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"0.45rem"}}>
                  <div className="h-sep" />
                  <div id="de-click-menu-notification" className="de-menu-notification" onClick={() => btn_icon_not(!shownot)} ref={refpopnot}>
                      {notifications.filter(n => !n.read).length > 0 && <div className="d-count">{notifications.filter(n => !n.read).length}</div>}
                      <i className="fa fa-bell"></i>
                      {shownot &&
                        <div className="popshow notif-pop">
                          <div className="nhead">
                            <h3>{t("Notifications")}</h3>
                            <span className="nnew">· {notifications.filter(n => !n.read).length} new</span>
                            <span className="nspacer"></span>
                            <span className="nmarkall" onClick={async (e) => {
                              e.stopPropagation();
                              try { await NotificationService.clearNotifications(); dispatch(thunkActions.fetchNotifications()); } catch (_) {}
                            }}>{t("MarkAllRead")}</span>
                          </div>
                          <ul>
                            {notifications && notifications.slice(0, 8).map((notification, index)  => {
                              const cat = categoryOf(notification.desc);
                              const vis = categoryVisual(cat);
                              return (
                                <li key={index} className={notification.read ? '' : 'unread'} onClick={(e) => {
                                  e.stopPropagation();
                                  const url = notification.url;
                                  if (!url) return;
                                  btn_icon_not(false); // ferme le pop-up
                                  // URL externe (http…) → navigation dure ; chemin interne relatif → history.push
                                  // (SPA, sans reload : évite le rebond vers la home dû à la ré-hydratation auth).
                                  // Une URL http de MÊME origine est convertie en chemin pour rester en client-side.
                                  if (/^https?:\/\//i.test(url)) {
                                    try {
                                      const u = new URL(url);
                                      if (u.origin === window.location.origin) {
                                        history.push(u.pathname + u.search + u.hash);
                                        return;
                                      }
                                    } catch (_) { /* URL invalide → repli window.location */ }
                                    window.location = url;
                                  } else {
                                    history.push(url);
                                  }
                                }}>
                                  <span className="nic" style={{ background: vis.bg }}>{vis.icon}</span>
                                  <div className="ntxt">
                                    <p>{notification.desc}</p>
                                    <time>{relativeTime(notification.createdAt)}</time>
                                  </div>
                                </li>
                              )
                            })}
                            {notifications && notifications.length === 0 &&
                              <li className="nempty"><div className="ntxt"><p>{t("NoNotificationsYet")}</p></div></li>
                            }
                        </ul>
                          <div className="nfoot" onClick={(e) => { e.stopPropagation(); btn_icon_not(false); history.push({pathname: EPATHS.NOTIFICATIONS}); }}>
                            <span className="notification-button">{t("ViewAllNotifications")}</span>
                          </div>
                        </div>
                        }
                  </div>
                  <div id="de-click-menu-profile" className="de-menu-profile" onClick={() => btn_icon_pop(!showpop)} ref={refpop}>
                      <SmartImage src={signedUser.accessToken ? getAvatarUrl(signedUser) : ''} srcSet={signedUser.accessToken ? getAvatarSrcSet(signedUser) : undefined} sizes="48px" fallback={DEFAULT_AVATAR} skeleton={false} alt=""/>
                      {showpop &&
                        <div className="popshow">
                          <div className="dd-head">
                              <SmartImage src={getAvatarUrl(signedUser)} srcSet={getAvatarSrcSet(signedUser)} sizes="64px" fallback={DEFAULT_AVATAR} skeleton={false} alt="" />
                              <div>
                                <div className="dd-name">
                                  {signedUser.accessToken ? signedUser.firstName : ''} {signedUser.accessToken ? signedUser.lastName : ''}
                                  {signedUser.roleId === EROLES.ADMIN && <span className="dd-role">{t("Admin")}</span>}
                                </div>
                                {signedUser.metamask && (
                                  <div className="dd-addr">
                                    <span className="dd-addr-text">{shortAddress(signedUser.metamask)}</span>
                                    <button
                                      type="button"
                                      className={`dd-addr-copy${copiedAddr ? ' copied' : ''}`}
                                      title={copiedAddr ? t('Copied') : t('CopyAddress')}
                                      aria-label={t('CopyWalletAddress')}
                                      onClick={copyWalletAddress}
                                    >
                                      <i className={`fa ${copiedAddr ? 'fa-check' : 'fa-clone'}`}></i>
                                      {copiedAddr && <span className="dd-addr-copied">{t('Copied')}</span>}
                                    </button>
                                  </div>
                                )}
                              </div>
                          </div>
                          {/* Solde earnicoins (devise in-game) — lu depuis Redux signedUser, own user */}
                          {signedUser.accessToken && (
                            <div className="dd-earnicoins">
                              <EarnicoinsBalance amount={signedUser.earnicoinsHoldings} size="sm" showUnit={false} />
                              {/* Raccourci achat de packs — poussé tout à droite (margin-left:auto), petit lien souligné magenta */}
                              <NavLink
                                to={EPATHS.EARNICOINS_PACKS}
                                className="dd-earnicoins-get"
                                onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.EARNICOINS_PACKS); }}
                              >
                                {t('GetEarnicoins')}
                              </NavLink>
                            </div>
                          )}
                          <div className="d-line"></div>
                          <ul className="de-submenu-profile">
                            {/* Profile — page publique unifiée /profile/:id */}
                            <li onClick={() => { btn_icon_pop(false); signedUser.id && handleRedirectToPath(`/profile/${signedUser.id}`); }}>
                              <NavLink to={signedUser.id ? `/profile/${signedUser.id}` : '#'} style={{}}>
                                <span>
                                  <i className="fa fa-user"></i> {t("Profile")}
                                </span>
                              </NavLink>
                            </li>
                            {/* My Collectibles — déplacé depuis la barre desktop (tout user connecté) */}
                            <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.MY_NFTS); }}>
                              <NavLink to={EPATHS.MY_NFTS} style={{}}>
                                <span>
                                  <i className="fa fa-th-large"></i> {t("MyCollectibles")}
                                </span>
                              </NavLink>
                            </li>
                            {/* Portfolio */}
                            <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.PORTFOLIO); }}>
                              <NavLink to={EPATHS.PORTFOLIO} style={{}}>
                                <span>
                                  <i className="fa fa-bar-chart"></i> {t("Portfolio")}
                                </span>
                              </NavLink>
                            </li>
                            {/* Watchlist — retiré du menu (2026-06-18) : info déjà présente dans le profil. */}
                            {/* My Bids & Offers — UI-09 */}
                            <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.MY_BIDS); }}>
                              <NavLink to={EPATHS.MY_BIDS} style={{}}>
                                <span>
                                  <i className="fa fa-gavel"></i> {t("MyBidsOffers")}
                                </span>
                              </NavLink>
                            </li>
                            {/* My Collections — déplacé depuis la barre desktop (roleId !== STANDARD) */}
                            {signedUser.roleId !== EROLES.STANDARD && (
                              <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.MY_COLLECTIONS); }}>
                                <NavLink to={EPATHS.MY_COLLECTIONS} style={{}}>
                                  <span>
                                    <i className="fa fa-folder"></i> {t("MyCollections")}
                                  </span>
                                </NavLink>
                              </li>
                            )}
                            {/* Wallet (Earni Wallet modal — distinct du Portfolio §différenciation libellé menu) */}
                            <li onClick={() => { btn_icon_pop(false); setWalletModalOpen(true); }}>
                              <span>
                                <i className="fa fa-credit-card"></i> {t("MyWalletMenu")}
                              </span>
                            </li>
                            {/* Gains — admin + snapshot */}
                            {(signedUser.roleId === EROLES.ADMIN || signedUser.isSnapshot) && (
                              <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.GAIN); }}>
                                <NavLink to={EPATHS.GAIN} style={{}}>
                                  <span>
                                    <i className="fa fa-exchange"></i> {t("Gains")}
                                  </span>
                                </NavLink>
                              </li>
                            )}
                            {/* Transactions */}
                            <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.TRANSACTIONS); }}>
                              <NavLink to={EPATHS.TRANSACTIONS} style={{}}>
                                <span>
                                  <i className="fa fa-money"></i> {t("Transactions")}
                                </span>
                              </NavLink>
                            </li>
                            {/* Support — tout utilisateur connecté */}
                            <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.SUPPORT); }}>
                              <NavLink to={EPATHS.SUPPORT} style={{}}>
                                <span>
                                  <i className="fa fa-question-circle"></i> {t("Support")}
                                </span>
                              </NavLink>
                            </li>
                            {/* Support console — isSupport ou admin */}
                            {(signedUser.isSupport || signedUser.roleId === EROLES.ADMIN) && (
                              <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.SUPPORT_AGENT); }}>
                                <NavLink to={EPATHS.SUPPORT_AGENT} style={{}}>
                                  <span>
                                    <i className="fa fa-headphones"></i> {t("SupportConsole")}
                                  </span>
                                </NavLink>
                              </li>
                            )}
                            {/* Invite friends — referral quick share */}
                            <li onClick={() => { btn_icon_pop(false); setReferralModalOpen(true); }}>
                              <span>
                                <i className="fa fa-gift"></i> {t("InviteFriends")}
                              </span>
                            </li>
                            {/* Settings — tous les rôles */}
                            <li onClick={() => { btn_icon_pop(false); handleRedirectToPath(EPATHS.SETTINGS); }}>
                              <NavLink to={EPATHS.SETTINGS} style={{}}>
                                <span>
                                  <i className="fa fa-sliders"></i> {t("Settings")}
                                </span>
                              </NavLink>
                            </li>
                            <li className="dd-signout" onClick={() => handleLogout()}>
                              <span>
                                <i className="fa fa-sign-out"></i> {t("SignOut")}
                              </span>
                            </li>
                          </ul>
                        </div>
                      }
                  </div>
                </div>}
              </div>
              {/* Bouton wallet MOBILE — centré dans la barre (mobile only via CSS), visible loggué OU
                  délogué : ouvre EarniWalletModal (connect si délogué / manage si loggué via initialFlow).
                  Notifications + avatar sont accessibles dans le drawer (burger) en mobile. */}
              <button className="de-menu-wallet-mobile" onClick={() => setWalletModalOpen(true)} aria-label={t("My wallet")}>
                {/* SVG INLINE (pas de data-URL CSS : un data-URL avec quotes casse la
                    minification prod et corrompt la règle CSS suivante — cause du bug logo desktop). */}
                <svg className="wallet-ico" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke={COLORS.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="2" y="7" width="20" height="14" rx="2" />
                  <path d="M16 3H8L2 7h20z" />
                  <rect x="16" y="12" width="6" height="6" rx="1" fill="rgba(194,24,166,0.15)" strokeWidth="1.5" />
                  <circle cx="19" cy="15" r="1" fill={COLORS.accent} stroke="none" />
                </svg>
              </button>
              {/* Hamburger — ouvre l'Offcanvas mobile */}
              <button className="nav-icon" onClick={() => setShowOffcanvas(true)} aria-label={t("OpenMenu")}>
                <div className="menu-line white"></div>
                <div className="menu-line1 white"></div>
                <div className="menu-line2 white"></div>
              </button>
      </div>
      </div>
      <HeaderDAV2 />

      {/* ── Offcanvas mobile nav ──────────────────────────────────────────────── */}
      <Offcanvas show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="start" className="earni-mobile-nav">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={LOGO} alt="Earniverse" style={{ height: '1.6rem' }} />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <nav className="emn-nav">
            <NavLink to={EPATHS.HOME} className="emn-link" onClick={() => setShowOffcanvas(false)}>
              <i className="fa fa-home"></i> {t("Get Started")}
            </NavLink>
            <div className="emn-section-label">{t("Maps")}</div>
            <NavLink to={EPATHS.MAP} className="emn-link emn-sub" onClick={() => setShowOffcanvas(false)}>{t("MapDetails")}</NavLink>
            <NavLink to={EPATHS.LAND} className="emn-link emn-sub" onClick={() => setShowOffcanvas(false)}>{t("BuyLand")}</NavLink>
            <NavLink to={EPATHS.TILE_MAP} className="emn-link emn-sub" onClick={() => setShowOffcanvas(false)}>{t("WebMap")}</NavLink>
            <NavLink to={EPATHS.EXPLORE} className="emn-link" onClick={() => setShowOffcanvas(false)}>
              <i className="fa fa-search"></i> {t("Explore")}
            </NavLink>
            <NavLink to={EPATHS.ACTIVITY} className="emn-link" onClick={() => setShowOffcanvas(false)}>
              <i className="fa fa-globe"></i> {t("Activity")}
            </NavLink>
            {signedUser.accessToken && (
              <NavLink to={EPATHS.MY_NFTS} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-th-large"></i> {t("MyCollectibles")}
              </NavLink>
            )}
            {signedUser.accessToken && (
              <NavLink to={EPATHS.PORTFOLIO} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-bar-chart"></i> {t("Portfolio")}
              </NavLink>
            )}
            {/* Watchlist — retiré du menu (2026-06-18) : info déjà présente dans le profil. */}
            {signedUser.accessToken && (
              <NavLink to={EPATHS.MY_BIDS} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-gavel"></i> {t("MyBidsOffers")}
              </NavLink>
            )}
            {signedUser.accessToken && signedUser.roleId !== EROLES.STANDARD && (
              <NavLink to={EPATHS.MY_COLLECTIONS} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-folder"></i> {t("MyCollections")}
              </NavLink>
            )}
          </nav>
          <div className="emn-divider" />
          {signedUser.accessToken ? (
            <div className="emn-profile">
              <div className="emn-profile-head">
                <SmartImage src={getAvatarUrl(signedUser)} fallback={DEFAULT_AVATAR} skeleton={false} alt="" className="emn-avatar" />
                <div>
                  <div className="emn-name">
                    {signedUser.firstName} {signedUser.lastName}
                    {signedUser.roleId === EROLES.ADMIN && <span className="emn-badge">{t("Admin")}</span>}
                  </div>
                  {signedUser.metamask && (
                    <div className="emn-addr">{shortAddress(signedUser.metamask)}</div>
                  )}
                </div>
              </div>
              <button className="emn-wallet-btn" onClick={() => { setShowOffcanvas(false); setWalletModalOpen(true); }}>
                <i className="fa fa-credit-card"></i> {t("My wallet")}
              </button>
              <NavLink to={signedUser.id ? `/profile/${signedUser.id}` : '#'} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-user"></i> {t("MyProfileLink")}
              </NavLink>
              {/* Notifications — accessible dans le drawer (la cloche quitte la barre mobile) */}
              <NavLink to={EPATHS.NOTIFICATIONS} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-bell"></i> {t("Notifications")}
                {notifications.filter(n => !n.read).length > 0 && <span className="emn-notif-count">{notifications.filter(n => !n.read).length}</span>}
              </NavLink>
              <NavLink to={EPATHS.TRANSACTIONS} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-money"></i> {t("Transactions")}
              </NavLink>
              <NavLink to={EPATHS.SUPPORT} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                <i className="fa fa-question-circle"></i> {t("Support")}
              </NavLink>
              {signedUser.accessToken && (
                <NavLink to={EPATHS.SETTINGS} className="emn-link" onClick={() => setShowOffcanvas(false)}>
                  <i className="fa fa-cog"></i> {t("Settings")}
                </NavLink>
              )}
              <div className="emn-divider" />
              <button className="emn-signout" onClick={() => { setShowOffcanvas(false); handleLogout(); }}>
                <i className="fa fa-sign-out"></i> {t("SignOut")}
              </button>
            </div>
          ) : (
            <div className="emn-connect">
              <button className="emn-connect-btn" onClick={() => { setShowOffcanvas(false); setWalletModalOpen(true); }}>
                {t("ConnectWallet")}
              </button>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      <CartCheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setIsCheckoutOpen(false)}
        cartItems={cartItems}
        cartTotal={cartTotal}
      />
      <ReferralQuickShareModal
        open={referralModalOpen}
        onClose={() => setReferralModalOpen(false)}
        referralLink={referralLink}
      />
      <ReferralAlreadyMemberModal
        open={alreadyMemberOpen}
        onClose={() => setAlreadyMemberOpen(false)}
        onInvite={() => { setAlreadyMemberOpen(false); setReferralModalOpen(true); }}
      />
      <ModalNoMetamask open={openNoWalletModal} onClose={() => setOpenNoWalletModal(false)} />
      <EarniWalletModal
        isOpen={walletModalOpen}
        onClose={() => { pendingCheckoutRef.current = false; pendingDarkRef.current = false; setWalletModalReason(''); setWalletModalOpen(false); }}
        onSuccess={handleWalletSuccess}
        apiBaseUrl={SERVER_URL}
        chainId={resolvedChainId}
        supportedWallets={['metaMask', 'coinbaseWallet', 'trustWallet', 'binanceWallet']}
        theme="GREY"
        /* FIX 2026-06-30 — flow par défaut = présence de session (accessToken), PAS id.
            Un user partiel { id, sans accessToken } (ex: localStorage hérité, ou compte wallet
            isVerified=false depuis SPEC-2026-06-29-auth-confirm-2fa.v1) gardait un id truthy →
            la modal s'ouvrait en MANAGE (« My wallets (0) / Link a wallet ») pour un visiteur
            déloggué, rendant le flux de connexion (PICKING) inatteignable. accessToken est le seul
            signal fiable « est connecté » (cohérent avec le reste du header). */
        initialFlow={signedUser?.accessToken ? 'manage' : 'connect'}
        contextBanner={walletModalReason === 'darkmode' ? {
          icon: '🌙',
          message: 'Dark mode is a saved account preference. Sign in or create an account to enable it. Your theme syncs across your devices.'
        } : null}
      />
      <ModalUELogin open={isShowUELogin} user={signedUser} onClose={() => setShowUELogin(false)} />
      <SessionTimeoutModal open={isTimeout} />
      <AuthGateModal />
      <EpicRegisterModal open={isEpicRegister}
        onClose={() => {
          setEpicRegister(false);
          localStorage.removeItem('_first');
        }}
        onSubmit={() => {

        }}/>
    </header>
    );
}
export default Header;